import { selectedStoreState, sharedStoreDataMapping } from "../services/store.service";
import '../../styles/web-components/store-location-with-map.scss';
import { toRawPhoneNumber, transformStorePhone } from "../helpers/transformations";
class StoreLocationWithMap extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.render(null);
        selectedStoreState.subscribe((store) => {
            if (store) {
                this.render(store);
            }
        });
    }
    render(storeInfo) {
        if (storeInfo) {
            const { address, city, storeHref } = sharedStoreDataMapping(storeInfo);
            this.renderStoreLocation(storeInfo, address, city, storeHref);
        }
        else {
            this.renderNoStoreLocation();
        }
    }
    renderStoreLocation(storeInfo, address, city, storeHref) {
        const storeInfoEl = `
      <h3 class="store-location-with-map__store-name">${storeInfo.SHOPIFY_DISPLAY_NAME}</h3>
      <p class="store-location-with-map__store-address">${address}<br> ${city}</p>
      <a href="${this.getAttribute("directions-link")}${encodeURIComponent(address + ', ' + city)}" target="_blank" class="store-location-with-map__store-directions">Get Directions</a>
      <p class="store-location-with-map__store-hours">${storeInfo.STORE_HOURS}</p>
      <a href="tel:${toRawPhoneNumber(storeInfo.PHONE)}" class="store-location-with-map__store-phone">${transformStorePhone(storeInfo.PHONE)}</a>
    `;
        const storeInfoContainer = this.querySelector('.store-location-with-map__store-info-container');
        if (storeInfoContainer) {
            storeInfoContainer.innerHTML = storeInfoEl;
        }
        const shopStoreCTA = this.querySelector('.store-location-with-map__cta--shop-store');
        if (shopStoreCTA) {
            shopStoreCTA.href = storeHref;
        }
        const mapEl = this.querySelector('#map-embed');
        if (mapEl) {
            mapEl.innerHTML = `
          <iframe
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0"
            loading="lazy"
            title="Map of ${storeInfo.SHOPIFY_DISPLAY_NAME}"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed/v1/place?key=${window.UNTUCKitConfig.googleMapsApiKey}&q=${storeInfo.LATITUDE},${storeInfo.LONGITUDE}&zoom=15">
          </iframe>
          `;
        }
        this.dataset.toggle = 'show-store';
    }
    renderNoStoreLocation() {
        this.dataset.toggle = 'no-store';
    }
}
if (!window.customElements.get("store-location-with-map")) {
    customElements.define("store-location-with-map", StoreLocationWithMap);
}
